import { validation } from 'site-modules/shared/components/form-validation/validation';
import { formatDate, parseDate } from 'client/site-modules/financing/utils/fields-validation';

export const VALIDATORS = {
  email: {
    test: validation.validateEmail,
    errorText: 'Please enter your correct email address.',
  },
  confirmEmail: {
    test: validation.validateEmail,
    errorText: 'Please enter your correct email address.',
  },
  firstName: {
    test: validation.validateFirstName,
    errorText: 'Please correct your first name. Special characters cannot be included.',
  },
  lastName: {
    test: validation.validateName,
    errorText: 'Please correct your last name. Special characters cannot be included.',
  },
  phoneNumber: {
    test: validation.validatePhoneNumber,
    errorText: 'Please enter a valid phone number.',
  },
  dateBirth: {
    test: validation.validateDateOfBirth,
    errorText: 'Please enter a valid date of birth',
  },
  employmentStatus: {
    test: validation.validateValue,
    errorText: 'Please enter your employment status.',
  },
  employmentStatusPrimary: {
    test: validation.validateValue,
    errorText: 'Please enter your employment status.',
  },
  employer: {
    test: validation.validateValue,
    errorText: 'Please enter employer name.',
  },
  employerPrimary: {
    test: validation.validateValue,
    errorText: 'Please enter employer name.',
  },
  jobTitle: {
    test: validation.validateValue,
    errorText: 'Please enter job title.',
  },
  jobTitlePrimary: {
    test: validation.validateValue,
    errorText: 'Please enter job title.',
  },
  workedYears: {
    test: validation.validateDigits,
    errorText: 'Please enter correct value.',
  },
  workedYearsPrimary: {
    test: validation.validateDigits,
    errorText: 'Please enter correct value.',
  },
  workedMonths: {
    test: validation.validateDigits,
    errorText: 'Please enter correct value.',
  },
  workedMonthsPrimary: {
    test: validation.validateDigits,
    errorText: 'Please enter correct value.',
  },
  annualIncome: {
    test: validation.validateValue,
    errorText: 'Please enter correct value.',
  },
  annualIncomePrimary: {
    test: validation.validateValue,
    errorText: 'Please enter correct value.',
  },
  additionalAnnualIncome: {
    test: validation.validateValue,
    errorText: 'Please enter correct value.',
    isOptional: true,
  },
  additionalAnnualIncomePrimary: {
    test: validation.validateValue,
    errorText: 'Please enter correct value.',
    isOptional: true,
  },
  homeAddress: {
    test: validation.validateAddress,
    errorText: 'Please enter your correct home address.',
  },
  aptNum: {
    test: validation.validateValue,
    errorText: 'Please enter your correct apt number.',
    isOptional: true,
  },
  city: {
    test: validation.validateCity,
    errorText: 'Please enter your correct city',
  },
  zip: {
    test: validation.validateZip,
    errorText: 'Please correct your zip.',
  },
  years: {
    test: validation.validateDigits,
    errorText: 'Please enter correct value.',
  },
  monthlyRent: {
    test: validation.validateValue,
    errorText: 'Please enter correct value.',
  },
};

export const SSN_FIELD_MASK = { pattern: '***-**-****', toValue: true, placeholder: 'Social Security Number' };
export const SSN_LAST_FOUR_FIELD_MASK = { pattern: '****', toValue: true, placeholder: 'Last 4 Digits of your SSN' };
export const DATE_OF_BIRTH_MASK = {
  mask: Date,
  pattern: 'Y{-}`m{-}`d',
  format: formatDate,
  parse: parseDate,
  toValue: true,
  placeholder: 'Date of Birth',
};
export const PHONE_MASK = { pattern: '(000) 000-0000', toValue: true, placeholder: 'Phone Number' };

export const DIGIT_CHAR = /^\d+$/;
